// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { LMFieldUtilService, LMFormatUtilService } from '@services/utils';
import { AppConstants, LMConditionUtilService, LMTransformOptions } from '@utils/index';

@Pipe({
  name: 'toDisplayValue',
  standalone: false
})
export class LMModelFieldToDisplayPipe implements PipeTransform {

  constructor(private lmFormatUtilService: LMFormatUtilService,
    private lmFieldUtilService: LMFieldUtilService,
    private lmConditionUtilService: LMConditionUtilService,) {
  }

  transform(modelFieldValue, specField: LMSpecField, options?: LMTransformOptions): string {
    if (specField === null || specField === undefined) {
      return modelFieldValue;
    }

    if (options?.doNotTransform) {
      // This is set for cube search form fields to allow ontological values to be appended to the actual value.
      // Mostly the numeric key field dimension is the one that will take the value as is, since it will not be a
      // numeric value after the ontological values are appended.
      if (specField && specField.type === AppConstants.NUMERIC && this.lmFieldUtilService.isBlank(specField.type, modelFieldValue)) {
        return '';
      }
      return modelFieldValue;
    }

    if (options?.allowMultiSelections) {
      if (Array.isArray(modelFieldValue)) {
        return modelFieldValue.map((valueMember) => this.lmFormatUtilService.toDisplayValueWithSpec(valueMember, specField, options)).join(AppConstants.MULTI_SEARCH_TERM_DELIMITER);
      }
    }

    if(options?.hasDisplayWhen) {
      if (this.lmConditionUtilService.isValid([ options.formFieldDisplayWhen.displayWhen ], options.formFieldDisplayWhen.model)) {
        return this.lmFormatUtilService.formatMessageRule(options.formFieldDisplayWhen.displayMsgRule, options.formFieldDisplayWhen.model);
      }
    }
    const value = this.lmFormatUtilService.toDisplayValueWithSpec(modelFieldValue, specField, options);

    if (specField.type === AppConstants.ALPHAUPPER) {
      return value.toString().toUpperCase();
    }

    return value;
  }
}
